import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { changeLanguage } from '../i18n';

const languages = [
  { code: 'ru', name: 'Русский', flag: '🇷🇺' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
];

const styles = {
  container: {
    position: 'relative',
  },
  button: {
    background: 'rgba(255, 255, 255, 0.1)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    borderRadius: '20px',
    padding: '6px 12px',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    cursor: 'pointer',
    color: '#fff',
    fontSize: '14px',
    transition: 'all 0.2s ease',
  },
  buttonHover: {
    background: 'rgba(255, 255, 255, 0.2)',
  },
  dropdown: {
    position: 'absolute',
    top: '100%',
    right: 0,
    marginTop: '8px',
    background: 'rgba(0, 0, 0, 0.9)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    borderRadius: '12px',
    overflow: 'hidden',
    zIndex: 1001,
    minWidth: '140px',
  },
  option: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '10px 14px',
    cursor: 'pointer',
    color: '#fff',
    fontSize: '14px',
    transition: 'background 0.2s ease',
    background: 'transparent',
    border: 'none',
    width: '100%',
    textAlign: 'left',
  },
  optionActive: {
    background: 'rgba(0, 212, 255, 0.2)',
  },
  optionHover: {
    background: 'rgba(255, 255, 255, 0.1)',
  },
  flag: {
    fontSize: '18px',
  },
  check: {
    marginLeft: 'auto',
    color: '#00d4ff',
  },
  backdrop: {
    position: 'fixed',
    inset: 0,
    zIndex: 1000,
  },
};

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [hoveredOption, setHoveredOption] = useState(null);

  const currentLang = languages.find((l) => l.code === i18n.language) || languages[0];

  const handleLanguageChange = async (langCode) => {
    await changeLanguage(langCode);
    setIsOpen(false);
  };

  return (
    <div style={styles.container}>
      <button
        style={styles.button}
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Change language"
      >
        <span style={styles.flag}>{currentLang.flag}</span>
        <span>🌐</span>
      </button>

      {isOpen && (
        <>
          <div style={styles.backdrop} onClick={() => setIsOpen(false)} />
          <div style={styles.dropdown}>
            {languages.map((lang) => (
              <button
                key={lang.code}
                style={{
                  ...styles.option,
                  ...(lang.code === i18n.language ? styles.optionActive : {}),
                  ...(hoveredOption === lang.code ? styles.optionHover : {}),
                }}
                onClick={() => handleLanguageChange(lang.code)}
                onMouseEnter={() => setHoveredOption(lang.code)}
                onMouseLeave={() => setHoveredOption(null)}
              >
                <span style={styles.flag}>{lang.flag}</span>
                <span>{lang.name}</span>
                {lang.code === i18n.language && <span style={styles.check}>✓</span>}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default LanguageSwitcher;
